import { render } from "./P063.vue?vue&type=template&id=38df2138&scoped=true"
import script from "./P063.vue?vue&type=script&lang=js"
export * from "./P063.vue?vue&type=script&lang=js"

import "./P063.vue?vue&type=style&index=0&id=38df2138&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38df2138"]])

export default __exports__